<template>
    <div
        class="md-search layout1 mg-bg"
        :class="{
            [layoutState]: true,
            mobile: isMobile,
            'hide-below': hideBelow,
            'for-cms': forCMS,
            'map-search-hide': !showSearchBar,
            'module-in-featured-area-search': page.pageKey === 'featured-area-search',
            'mg-container': page.pageKey === 'featured-area-search'
        }"
        :style="{ ...style,...spaceStyle, ...currentColorStyle }"
        v-if="listingSourceReady"
    >
        <component
            :is="mdSearchBar"
            ref="listingSearch"
            v-if="showSearchBar"
            :searchBarOnly="false"
            @conditionChange="conditionChange"
            :propsToData="dataToSearchBar"
        />
        <SearchResult
            cls="show-search mg-magtop-40 all-screen"
            :hideBelow="hideBelow"
            :mapSearchText="mapSearchText"
            :hideSearchChoose="hideSearchChoose"
            :mapDrawTip="mapDrawTip"
            :showSearchBar="showSearchBar"
            :showSchool="showSchool"
            :propsToData="dataToSearchResult"
            :searchHeight="searchHeight"
            :style="searchResultStyle"
            ref="result"
        />
    </div>
</template>
<script>

import Core from '../index';
import Broker from '../_mixins/broker';
import { colorBlock } from '../../defaultSpacing';
import searchBarMixin from '../../md-search-bar-mixin';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
import { getAsyComponent } from '@/common/utils/load-module.js';
import { mapActions } from '@/store/helpers';
import { SET_PRIMARY_KEYS_MAP } from '@/modules/md-search-bar/_store/types';
import { getPrimaryKeysMap } from '@/modules/md-search-bar/_util';
import { calcColorRootVar } from '@/init/data/handlerData.js';
export default {
    provide() {
        return {
            colorStyle: this.currentColorStyle,
            showSearchBar: this.showSearchBar,
            setApplyMap: this.setApplyMap
        }
    },
    mixins: [Core, Broker, searchBarMixin('layout1'), colorMixin(), spaceMixin()],
    components: {
        SearchResult: getAsyComponent(() =>
            import(
                /*webpackChunkName: 'components/search-result/layout1' */
                '../../../components/search-result/layout1/index.vue'
            ))
    },
    data: function() {
        return {
            ...colorBlock,
            theme: 'layout1',
            primaryKeysMap: getPrimaryKeysMap()
        };
    },
    computed: {
        style({ layoutState }) {
            if (layoutState === 'map') {
                return { height: this.height }
            }
            return {}
        },
        searchResultStyle({ isMobileSize, layoutState, searchHeight }) {
            return isMobileSize && layoutState === 'map' ? { height: searchHeight + 'px' } : {}
        },
        currentColorStyle() {
            return {
                ...this.colorStyle,
                ...calcColorRootVar.call(this, {
                    colors: ['--g-primary-color_5']
                })
            }
        }
    },
    created() {
        this.setPrimaryKeysMap(this.primaryKeysMap)
    },
    methods: {
        ...mapActions({
            setPrimaryKeysMap: SET_PRIMARY_KEYS_MAP
        })
    }
};
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
.md-search {
    position: relative;
}
.md-search.layout1 {
    display: flex;
    flex-direction: column;
}
.md-search.map.hide-below ~ * {
    display: none;
}
.map-search-hide .map-tool.search {
    display: none;
}
.md-search.for-cms {
    .md-listing-search {
        .md-search-more {
            padding: 20px 0;
            background-color: white;
            .search-by-section {
                .keyword-container {
                    margin-right: 15px;
                    .search-category {
                        border: 1px solid #c6c8d1;
                        border-radius: 4px;
                        .keyword {
                            .search-input {
                                height: 42px;
                            }
                        }
                        .keyword-submit {
                            height: 42px;
                            line-height: 42px;
                        }
                    }
                }
                .search-more {
                    margin-top: 0;
                    .search-detail-wrap {
                        .search-detail-item {
                            height: 36px;
                            line-height: 34px;
                            &.show-list {
                                background-color: #ebecf1;
                            }
                            &:not(:last-child) {
                                margin-right: 15px;
                            }
                            .logo {
                                display: none;
                            }
                            .box-div {
                                border-radius: 4px;
                                &:after {
                                    content: none;
                                }
                            }
                        }
                    }
                    .list-panel {
                        border-radius: 4px;
                        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                        border: solid 1px #c6c8d1;
                    }
                    .range-input-parent {
                        input {
                            border-radius: 4px;
                            box-shadow: inset 0 2px 4px 0 rgba(0, 10, 30, 0.1);
                            border: solid 1px #c6c8d1;
                        }
                    }
                    .more-list {
                        border-radius: 4px;
                        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
                        border: solid 1px #c6c8d1;
                        .section-box .selectdown {
                            height: 36px;
                            line-height: 34px;
                            border: solid 1px #e1e2e6;
                            border-radius: 4px;
                            box-shadow: inset 0 2px 4px 0 rgba(0, 10, 30, 0.1);
                        }
                        .keywords-input {
                            border: solid 1px #e1e2e6;
                            border-right: none;
                            border-radius: 4px 0 0 4px;
                            box-shadow: inset 0 2px 4px 0 rgba(0, 10, 30, 0.1);
                        }
                    }
                }
            }
        }
    }
   
}

.md-search.layout1.map.hide-below {
    margin-bottom: 0 !important;
    .comp-pagination {
        margin-bottom: 60px;
    }
}
</style>
